import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'Obra'

const PatchField = (data = {}, config = {}) => APIClient.patch(`${APIPci}/${resourceName}`, data, config)
const GetAll = (companyId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/${companyId}`, data, config)

const PCIWorkRepository = {
  PatchField,
  GetAll
}

export default PCIWorkRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/work.js